export const userFormData = (dropdownRole) => {
    return [
        {
            id: "nama_user",
            label: "Nama User",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Nama User'
            }]
        },
        {
            id: "email",
            label: "Email",
            fields: [{
                type: 'email',
                placeholder: 'Masukan Email User'
            }]
        },
        {
            id: "no_hp",
            label: "Nomor Hp",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Nomor Hp User'
            }]
        },
        {
            id: "id_role",
            label: "Role",
            fields: [{
                type: 'option',
                options: dropdownRole
            }]
        },
        {
            id: "alamat",
            label: "Alamat",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Alamat User'
            }]
        },
        {
            id: "image_profile",
            label: "Upload Foto User",
            fields: [{
                type: 'file',
            }]
        }
    ]
}

export const userFormEditData = (dropdownRole) => {
    return [
        {
            id: "nama_user",
            label: "Nama User",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Nama User'
            }]
        },
        {
            id: "id_role",
            label: "Role",
            fields: [{
                type: 'option',
                options: dropdownRole
            }]
        },
        {
            id: "no_hp",
            label: "Nomor Hp",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Nomor Hp User'
            }]
        },
        {
            id: "alamat",
            label: "Alamat",
            fields: [{
                type: 'input',
                placeholder: 'Masukan Alamat User'
            }]
        }
    ]
}